module.exports = __webpack_public_path__ + "img/new-agency.01b37cef.jpg";